import React, { useEffect, useState } from "react";
import { BASE_URL } from "../config";

function AddProductForm() {
  const [productData, setProductData] = useState({
    name: "",
    size: "",
    category: "",
    location_id: "",
    magazyn_id: "",
    sku: "",
    ksfv: "",
    buy_price: "",
    sale_price: "",
    consignment_price: "",
    note: "",
    image: "",
  });

  const [locations, setLocations] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/api/locations`)
      .then((response) => response.json())
      .then((data) => setLocations(data))
      .catch((error) => console.error("Error fetching locations:", error));

    fetch(`${BASE_URL}/api/warehouses`)
      .then((response) => response.json())
      .then((data) => setWarehouses(data))
      .catch((error) => console.error("Error fetching warehouses:", error));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    
    if (type === 'file') {
      setProductData((prev) => ({
        ...prev,
        [name]: files[0]
      }));
    } else {
      setProductData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      
      Object.keys(productData).forEach(key => {
        if (key === 'image' && productData[key]) {
          formData.append('image', productData[key]); 
        } else if (productData[key]) {
          formData.append(key, productData[key]); 
        }
      });

      const response = await fetch(`${BASE_URL}/api/add_product`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Error adding product");
      }

      // Reset form or provide feedback as needed
      alert("Produkt został dodany pomyślnie");
      
      // Reset form after successful submission
      setProductData({
        name: "",
        size: "",
        category: "",
        location_id: "",
        magazyn_id: "",
        sku: "",
        ksfv: "",
        buy_price: "",
        sale_price: "",
        consignment_price: "",
        note: "",
        image: "",
      });
    } catch (error) {
      console.error(error);
      alert("Wystąpił błąd podczas dodawania produktu");
    }
  };

  return (
    <div className="container mt-5">
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-4">
            <label className="form-label">SKU</label>
            <input
              type="text"
              className="form-control"
              name="sku"
              value={productData.sku}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Nazwa</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={productData.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">UKS/FV</label>
            <input
              type="text"
              className="form-control"
              name="ksfv"
              value={productData.ksfv}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Rozmiar</label>
            <input
              type="text"
              className="form-control"
              name="size"
              value={productData.size}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Cena zakupu</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="buy_price"
              value={productData.buy_price}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Cena sklep</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="sale_price"
              value={productData.sale_price}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Cena komisowa</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="consignment_price"
              value={productData.consignment_price}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Kategoria</label>
            <input
              type="text"
              className="form-control"
              name="category"
              value={productData.category}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Zdjęcie</label>
            <input
              type="file"
              className="form-control"
              name="image"
              onChange={handleChange}
              accept="image/*"
            />
          </div>
          <div className="col-md-4">
            <label className="form-label">Lokalizacja</label>
            <select
              className="form-select"
              value={productData.location_id}
              onChange={handleChange}
              name="location_id"
            >
              <option value="">Wybierz lokalizację</option>
              {locations.map((item) => (
                <option key={item.location_id} value={item.location_id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">Magazyn</label>
            <select
              className="form-select"
              value={productData.magazyn_id}
              onChange={handleChange}
              name="magazyn_id"
            >
              <option value="">Wybierz magazyn</option>
              {warehouses.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-12">
            <label className="form-label">Notatka</label>
            <textarea
              className="form-control"
              name="note"
              value={productData.note}
              onChange={handleChange}
              rows="4"
              style={{ resize: "vertical", minHeight: "100px" }}
            />
          </div>
        </div>
        <div className="col-12 mt-3">
          <button type="submit" className="btn btn-primary">
            Dodaj produkt
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddProductForm;
